if (!customElements.get('ts-hero')) {
  customElements.define('ts-hero', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ts-hero__track');
      this.slides = [...this.querySelectorAll('.ts-hero__slide')];
      this.dots = this.querySelector('.ts-hero__dots');
      this.index = 0;
      this.slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ts-hero__dot';
        dot.setAttribute('aria-label', `バナー${index + 1}を表示`);
        dot.addEventListener('click', () => this.show(index));
        this.dots.appendChild(dot);
      });
      this.querySelector('.ts-hero__prev').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('.ts-hero__next').addEventListener('click', () => this.show(this.index + 1));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.show(0);
      this.start();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      [...this.dots.children].forEach((dot, i) => dot.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
    }
    start() { this.stop(); this.timer = setInterval(() => this.show(this.index + 1), 7000); }
    stop() { if (this.timer) clearInterval(this.timer); }
    disconnectedCallback() { this.stop(); }
  });
}
